export enum DISPLAY_STEP_PROGRESS {
  'ENABLE' = 'ENABLE',
  'DISABLE' = 'DISABLE'
}